module.exports = __webpack_public_path__ + "static/img/function1.62e13e09.png";